<template>
  <div>
    <div>
      <h2 class="mb-5">
        What working hours are you looking for?
      </h2>
    </div>
    <div v-if="isFetchingWorkingHours">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <Checkbox
      v-else
      @change="val => (selectedWorkingHours = val)"
      :selected-values="initialSelectedWorkingHours"
      :options="options"
      isLarge
      mixed
    />
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { ADD_USER_JOB_PREFERENCE } from "@/store/modules/users/actions";
import { createNamespacedHelpers } from "vuex";
import { FETCH_WORKING_HOURS_GROUPINGS } from "@/store/modules/data/actions";
import {
  GET_WORKING_HOURS_GROUPINGS,
  GET_IS_FETCHING_WORKING_HOURS_GROUPINGS
} from "@/store/modules/data/getters";
import { map, toString } from "lodash";
import Checkbox from "@/components/common/Checkbox";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapGetters: mapDataGetters, mapActions } = createNamespacedHelpers(
  DATA_NAMESPACE
);
const { mapActions: mapUserActions } = createNamespacedHelpers(USERS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "WorkingHours",
  components: {
    PrimaryButton,
    Checkbox
  },
  props: {
    userId: String
  },
  async created() {
    this.fetchWorkingHours();
    this.selectedWorkingHours = [...this.initialSelectedWorkingHours];
  },
  data() {
    return {
      selectedWorkingHours: [],
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    initialSelectedWorkingHours() {
      return map(this.userData.workingHoursGroupings, "id");
    },
    options() {
      return map(this.workingHours, ({ name, id }) => ({
        label: name,
        value: id
      }));
    },
    ...mapDataGetters({
      workingHours: GET_WORKING_HOURS_GROUPINGS,
      isFetchingWorkingHours: GET_IS_FETCHING_WORKING_HOURS_GROUPINGS
    })
  },
  methods: {
    ...mapActions({
      fetchWorkingHours: FETCH_WORKING_HOURS_GROUPINGS
    }),
    ...mapUserActions({
      addUserJobPreference: ADD_USER_JOB_PREFERENCE
    }),
    async nextStep() {
      this.$emit("nextStep");
    },
    async handleUpload() {
      this.isLoading = true;
      await this.addWorkingHours();
      this.isLoading = false;
    },
    async addWorkingHours() {
      await this.addUserJobPreference({
        userId: this.userId,
        data: {
          jobPreferenceIds: map(this.selectedWorkingHours, val =>
            toString(val)
          ),
          jobPreferenceType: "working_hours_grouping"
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
